import { apiMedService, apiReports } from '@/api'
import { logSlice } from '@/modules/Login/LoginSlice'
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { appSlice } from './app'
import { dictionarieSlice } from './dictionarie'
import { driverTasksSlice } from './driverTasks'
import { editDictionarieSlice } from './editDictionarie'
import { Mutex } from 'async-mutex'

const devMode = process.env.NODE_ENV === 'development'

export const mutex = new Mutex()

export const store = configureStore({
  reducer: {
    [appSlice.name]: appSlice.reducer,
    [driverTasksSlice.name]: driverTasksSlice.reducer,
    [dictionarieSlice.name]: dictionarieSlice.reducer,
    [editDictionarieSlice.name]: editDictionarieSlice.reducer,
    [apiMedService.reducerPath]: apiMedService.reducer,
    [apiReports.reducerPath]: apiReports.reducer,
    [logSlice.name]: logSlice.reducer,
  },
  devTools: devMode,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      apiMedService.middleware,
      apiReports.middleware,
    ]),
})

setupListeners(store.dispatch)
